import { Link } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';
import { useLanguage } from '../context/LanguageContext';
import { ReactComponent as Logo } from '../assets/86 ICE La Migra_Secondary Identity Black.svg';

const Home = () => {
    const { translate, language } = useLanguage();

    const demands = [
        {
            title: translate('DEMAND_PREPAREDNESS_TITLE'),
            description: translate('DEMAND_PREPAREDNESS_DESC')
        },
        {
            title: translate('DEMAND_4THAMENDMENT_TITLE'),
            description: translate('DEMAND_4THAMENDMENT_DESC')
        },
        {
            title: translate('DEMAND_SAFETY_TITLE'),
            description: translate('DEMAND_SAFETY_DESC')
        },
        {
            title: translate('DEMAND_SUPPORT_TITLE'),
            description: translate('DEMAND_SUPPORT_DESC')
        }
    ];


    const actions = [
        {
            title: translate('ACTION_RESTAURANT_GOEERS_TITLE'),
            description: translate('ACTION_RESTAURANT_GOEERS_DESC'),
            link: '/restaurant-goers',
            button: translate('ACTION_RESTAURANT_GOEERS_BUTTON')
        },
        {
            title: translate('ACTION_RESTAURAUNT_WORKERS_TITLE'),
            description: translate('ACTION_RESTAURAUNT_WORKERS_DESC'),
            link: '/restaurant-workers',
            button: translate('ACTION_RESTAURAUNT_WORKERS_BUTTON')
        },
        {
            title: translate('ACTION_RESTAURAUNT_OWNERS_TITLE'),
            description: translate('ACTION_RESTAURAUNT_OWNERS_DESC'),
            link: '/restaurant-owners',
            button: translate('ACTION_RESTARUANT_OWNERS_BUTTON')
        },
    ];

    return (
        <main>
            <section className="hero">
                <div className="half-and-half sixty-forty">
                    <div className="hero-content left-col">
                        <h1 className='hero-header sr-only'>{translate('HERO_TITLE')}</h1>
                        <Logo title="86 ICE/LA MIGRA" />
                        <p className="hero-subtitle">{translate('HERO_SUBTITLE')}</p>
                        <div className="hero-buttons">
                            <HashLink to="/#take-action" className="btn btn-primary">
                                {translate('HERO_CTA_BUTTON')}
                            </HashLink>

                            <Link to="/report-an-incident" className="btn btn-primary">
                                {translate('HERO_CTA_BUTTON_2')}
                            </Link>
                        </div>
                    </div>
                    <div className="right-col">
                        <img
                            src={require('../assets/image1.jpg')}
                            alt={translate('HERO_IMAGE_ALT')}
                            className="hero-image"
                        />
                    </div>
                </div>
            </section>

            <section className="actions" id="take-action">
                <div className="container">
                    <h2>{translate('ACTIONS_SECTION_TITLE')}</h2>
                    <div className="actions-grid">
                        {actions.map((action, index) => (
                            <Link key={index} className="action-card" to={action.link}>
                                <h4>{action.title}</h4>
                                <p>{action.description}</p>
                                <div className="button">
                                    {action.button}
                                </div>
                            </Link>
                        ))}
                    </div>
                </div>

            </section>

            <section className="demands">
                <div className="container">
                    <h2>{translate('DEMANDS_SECTION_TITLE')}</h2>

                    <div className="demands-grid">
                        {demands.map((demand, index) => (
                            <div key={index} className="demand-card">
                                <h4>{demand.title}</h4>
                                <p>{demand.description}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <section className="receipt-section">
                <div className="">
                    <div className="half-and-half reverse">
                        <div className="receipt-content left-col">
                            <h2>{translate('RECEIPT_SECTION_TITLE')}</h2>
                        </div>
                        <div className="right-col">
                            <img
                                src={require((language === "en" ? '../assets/86Ice_Receipt_Final.png' : '../assets/86LaMigra_Receipt_Final.png'))}
                                alt={translate('RECEIPT_IMAGE_ALT')}
                                className="hero-image"
                            />
                        </div>
                    </div>
                </div>
            </section>



            <section className="cta-section">
                <div className="container">
                    <div className="cta-content">
                        <h3>{translate('CTA_SECTION_TITLE')}</h3>
                        <p>{translate('CTA_SECTION_DESC')}</p>
                        <Link to="/report-an-incident" className="btn btn-primary">
                            {translate('CTA_SECTION_BUTTON')}
                        </Link>
                    </div>
                </div>
            </section>


        </main>
    );
};

export default Home;